import {useQuery} from '@tanstack/react-query';
import ConfigurationException from '../../exceptions/ConfigurationException';
import app from '../../helpers/app';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';
import React from 'react';
import {FormModelHttpResponse, FormModelProviderProps} from '../../@types/components/Form';

export default function FormModelProvider<Model extends IEmptyModel = IEmptyModel>(props: FormModelProviderProps<Model>) {
    const queryResult = useQuery<FormModelHttpResponse<Model>, Error>(props.query.queryKey, () => {
        if (!props.requestUri.length) {
            throw new ConfigurationException('Exceptions.configuration.model-form-request-uri-not-found');
        }

        return app('http').request(props.requestUri, {
            method: props.requestMethod ?? 'GET',
            body: props.requestBody
        });
    }, props.query.options);

    return <>{props.children(queryResult)}</>;
}
